module.exports = __webpack_public_path__ + "img/sence.a5b26cd9.png";